import { RootState } from 'store';

const BulkAssigneesState = (state: RootState) => state.weeklyPlanner.bulkAssignees;

export const selectBulkAssignees = (state: RootState) => BulkAssigneesState(state).rows;
export const selectBulkAssigneesLoading = (state: RootState) => BulkAssigneesState(state).loading;
export const selectBulkAssigneesError = (state: RootState) => BulkAssigneesState(state).error;
